import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { format } from "date-fns";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // Main styles
import "react-date-range/dist/theme/default.css"; // Theme styles
import "./style.css";

const DateSelector = ({
  label,
  defaultDate = "",
  minDate,
  maxDate,
  onDateChange,
  width,
  styles,
  placeholder,
  dateFormat,
}) => {
  const [selectedDate, setSelectedDate] = useState(defaultDate);
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const calendarRef = useRef(null);
  const dateBoxRef = useRef(null);

  useEffect(() => {
    if (defaultDate) {
      onDateChange(defaultDate);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        !dateBoxRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateChange(format(date, "yyyy-MM-dd"));
    setShowCalendar(false);
  };

  const handleDivClick = () => {
    if (!showCalendar) {
      const box = dateBoxRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: box.bottom + window.scrollY,
        left: box.left + window.scrollX,
      });
    }
    setShowCalendar((prev) => !prev);
  };

  const renderCalendar = () => (
    <div
      ref={calendarRef}
      style={{
        position: "absolute",
        top: `${calendarPosition.top}px`,
        left: `${calendarPosition.left}px`,
        zIndex: 9999,
        background: "#fff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
      }}
    >
      <Calendar
        date={selectedDate ? new Date(selectedDate) : new Date()}
        onChange={handleDateChange}
        minDate={minDate ? new Date(minDate) : undefined}
        maxDate={maxDate ? new Date(maxDate) : undefined}
        color="#22ccb2"
      />
    </div>
  );

  return (
    <div style={{ position: "relative" }}>
      {label && (
        <p className="mb-2" style={{ fontSize: "14px", color: "#333" }}>
          {label}
        </p>
      )}
      <div
        ref={dateBoxRef}
        onClick={handleDivClick}
        style={{
          ...styles,
          padding: "8px 10px",
          border: "1px solid var(--light-grey)",
          borderRadius: "8px",
          cursor: "pointer",
          width: width,
          color: "#333",
        }}
        className="date-box"
      >
        {selectedDate
          ? format(new Date(selectedDate), dateFormat ?? "EEE MMM d")
          : placeholder}
      </div>
      {showCalendar && ReactDOM.createPortal(renderCalendar(), document.body)}
    </div>
  );
};

export default DateSelector;
